export default __webpack_public_path__ + "static/media/geetaBudhiraja.762c79f7.webp";